import type { AppRouter } from "@sunfish/api";
import { createTRPCReact } from "@trpc/react-query";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";

export type RouterInput = inferRouterInputs<AppRouter>;
export type RouterOutput = inferRouterOutputs<AppRouter>;

export const trpc = createTRPCReact<AppRouter>();

export const useTRPC = () => trpc;
export const useTRPCUtils = () => trpc.useUtils();
export const useTRPCClient = () => {
	const utils = trpc.useUtils();
	return utils.client;
};
